import module from "./r2Module"
import r2View from "./r2View.html"
import angular from "angular"

module.directive("nlgR2", [() => {
    return {
        restrict: "E",
        template: r2View,
        scope: {
            supplyMode: "="
        },
        controller: ["$scope", "r2SystemVersionService", "supplyService", function ($scope, r2SystemVersionService, supplyService) {

            r2SystemVersionService.getLocalVersion().then(data => {
                var info = angular.isArray(data) ? data[0] : data
                $scope.localVersionStr = info.version
            })

            $scope.isSupplyMode = function () {
                return $scope.supplyMode === true || supplyService.isSupplyMode()
            }
            $scope.getRoutingSessionRestrictedName = function () {
                return supplyService.getRoutingSessionRestrictedName() || undefined
            }
        }]
    }
}])